// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { ParticipantDto } from '../_module/dto/participant.dto';
import { wsc } from '../wsc';
import { Observable } from 'rxjs';

export class BrandLotteryModel {
  static listenBonusDrawAward(): Observable<string> {
    return wsc.subscribe('/ws/brand-lottery/listenBonusDrawAward') as any;
  }

  static listenIsWinner(): Observable<boolean> {
    return wsc.subscribe('/ws/brand-lottery/listenIsWinner') as any;
  }

  static listenIsFinished(): Observable<boolean> {
    return wsc.subscribe('/ws/brand-lottery/listenIsFinished') as any;
  }

  static bonusDraw(title: string): Promise<void> {
    return wsc.execute('/ws/brand-lottery/bonusDraw', title) as any;
  }

  static fetchIsWinner(): Promise<boolean> {
    return wsc.execute('/ws/brand-lottery/fetchIsWinner') as any;
  }

  static fetchIsFinished(): Promise<boolean> {
    return wsc.execute('/ws/brand-lottery/fetchIsFinished') as any;
  }

  static fetchWinners(): Promise<ParticipantDto[]> {
    return wsc.execute('/ws/brand-lottery/fetchWinners') as any;
  }

  static setWinner(winnerIdentifiers: string[]): Promise<void> {
    return wsc.execute('/ws/brand-lottery/setWinner', winnerIdentifiers) as any;
  }

  static setIsSpinExecuted(): Promise<void> {
    return wsc.execute('/ws/brand-lottery/setIsSpinExecuted') as any;
  }

  static isSpinExecuted(): Observable<boolean> {
    return wsc.subscribe('/ws/brand-lottery/isSpinExecuted') as any;
  }

  static fetchIsFilmstripExecuted(): Promise<boolean> {
    return wsc.execute('/ws/brand-lottery/fetchIsFilmstripExecuted') as any;
  }
}
// db86c514f8c1faa6b3da50070c7f40f154dc618fb89a8651fcd5a531cefc14db
